import React from 'react'
import assetConfigs from 'app/configs/assetConfigs'
import { makeStyles } from '@material-ui/styles'
import { useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { useIntl, FormattedMessage } from 'react-intl'
import AddIcon from '@material-ui/icons/Add'
import Typography from '@material-ui/core/Typography'
import {
  openTopicDialog,
  setTopicDialogState,
} from './store/actions/topic-action'
import clsx from 'clsx'

const useStyles = makeStyles(() => ({
  emptyTopic: {
    width: '420px',
  },
  emptyTopicTitle: {
    textAlign: 'center',
    color: '#064e75',
    marginTop: '22px',
    fontSize: '20px',
    fontWeight: 'bold',
  },
  emptyTopicButton: {
    width: '180px',
    height: ' 34px',
    color: 'white',
    marginTop: '22px',
    fontWeight: 'bold',
    fontSize: '14px',
  },
  emptyTopicBody: {
    background: 'white',
    borderRadius: '15px',
    padding: '12px 20px 10px 20px',
    border: '1px solid white',
  },
  emptyTopicBodyText: {
    fontSize: '14px',
    fontWeight: '400',
  },
}))

export default () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const body1 = formatMessage({
    id: 'notification.topics.empty.body1',
  })
  const body2 = formatMessage({
    id: 'notification.topics.empty.body2',
  })
  return (
    <>
      <div className={classes.emptyTopicBody}>
        <Typography className={classes.emptyTopicBodyText}>{body1}</Typography>
        <Typography className={clsx(classes.emptyTopicBodyText, 'mt-16')}>
          {body2}
        </Typography>
      </div>
      <div className="m-auto mt-12 flex flex-col items-center">
        <img
          className={classes.emptyTopic}
          alt="add topic card"
          src={assetConfigs.topicPageEmptyLogo}
        />
        <Typography className={classes.emptyTopicTitle}>
          <FormattedMessage id="notifications.topics.empty.title" />
        </Typography>
        <Button
          onClick={() => {
            dispatch(setTopicDialogState(null))
            dispatch(openTopicDialog())
          }}
          style={{ backgroundColor: ' #0073b1' }}
          startIcon={<AddIcon style={{ fontSize: '24px' }} />}
          className={classes.emptyTopicButton}
        >
          <div>
            <FormattedMessage id="notifications.topics.empty.button.label" />
          </div>
        </Button>
      </div>
    </>
  )
}
